import React from 'react';
import { useSelector } from 'react-redux';
import PageLayout from '../../../components/common/PageLayout';
import StripeIntegrationContainer from '../../blocks/StripeIntegrationContainer';
import SupplierAdminHeader from '../../../components/common/SupplierAdminHeader';

export default function SupplierAdminGeneralContainer() {
  const supplierId = useSelector((state) => state.role.supplierId);
  const pageHero = <SupplierAdminHeader supplierId={supplierId} title="General" />;

  return (
    <PageLayout top={pageHero}>
      <StripeIntegrationContainer />
    </PageLayout>
  );
}
